// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ticket-section {
    font-family: 'DM Sans', sans-serif;
    font-weight: 700;
    line-height: 100%;
}
.ticket-box table thead tr th {
    text-transform: none;
    font-family: 'DM Sans', sans-serif;
    font-weight: 400;
    font-size: 18px;
    line-height: 100%;
    letter-spacing: 0;
    padding-bottom: 16px;
}
.ticket-box table tbody tr {
    justify-content: space-between;
    padding-top: 24px;
    padding-right: 32px;
    padding-bottom: 24px;
    padding-left: 32px;
    border-radius: 12px;
}
.ticket-box table tbody tr td {
    color: #1E1517;
    font-family: 'DM Sans', sans-serif;
    font-weight: 700;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0;
}
.ticket-box table tbody tr.disabled-ticket td {
    color: #A1A1A1;
}
.ticket-box table tbody tr.disabled-ticket td button {
    background-color: #F8F5F4;
}
.ticket-box .summary {

}
.ticket-box .summary .title {
    font-family: 'DM Sans', sans-serif;
    font-weight: 800;
    font-size: 24px;
    line-height: 100%;
    letter-spacing: 0;
}
.ticket-box .summary .item {
    font-family: 'DM Sans', sans-serif;
    font-weight: 400;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0;
}
.ticket-box .sum {
    font-family: 'DM Sans', sans-serif;
    font-weight: 700;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: right;
}
.ticket-box .sum span {
    font-family: 'DM Sans', sans-serif;
    font-weight: 400;
    font-size: 18px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: right;
}
.ticket-box .value {
    font-family: 'DM Sans', sans-serif;
    font-weight: 800;
    font-size: 26px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: right;
    color: #7A1F35;
}
.footer .link {
    cursor: pointer;
}
.react-datepicker-wrapper {
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,oBAAoB;IACpB,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,yBAAyB;AAC7B;AACA;;AAEA;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;AACf","sourcesContent":[".ticket-section {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 700;\n    line-height: 100%;\n}\n.ticket-box table thead tr th {\n    text-transform: none;\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 100%;\n    letter-spacing: 0;\n    padding-bottom: 16px;\n}\n.ticket-box table tbody tr {\n    justify-content: space-between;\n    padding-top: 24px;\n    padding-right: 32px;\n    padding-bottom: 24px;\n    padding-left: 32px;\n    border-radius: 12px;\n}\n.ticket-box table tbody tr td {\n    color: #1E1517;\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 100%;\n    letter-spacing: 0;\n}\n.ticket-box table tbody tr.disabled-ticket td {\n    color: #A1A1A1;\n}\n.ticket-box table tbody tr.disabled-ticket td button {\n    background-color: #F8F5F4;\n}\n.ticket-box .summary {\n\n}\n.ticket-box .summary .title {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 800;\n    font-size: 24px;\n    line-height: 100%;\n    letter-spacing: 0;\n}\n.ticket-box .summary .item {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 100%;\n    letter-spacing: 0;\n}\n.ticket-box .sum {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 100%;\n    letter-spacing: 0;\n    text-align: right;\n}\n.ticket-box .sum span {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 100%;\n    letter-spacing: 0;\n    text-align: right;\n}\n.ticket-box .value {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 800;\n    font-size: 26px;\n    line-height: 100%;\n    letter-spacing: 0;\n    text-align: right;\n    color: #7A1F35;\n}\n.footer .link {\n    cursor: pointer;\n}\n.react-datepicker-wrapper {\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
